import { SpinnerCircular } from 'spinners-react';

export const Spinner = () => {
  <>
    <SpinnerCircular
      size={100}
      thickness={100}
      speed={100}
      color="#FF6B08"
      secondaryColor="rgba(0, 0, 0, 0.25)"
    />
  </>;
};
